import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../../utils/breadCrumbs";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import {
  ContainerBB,
  TitleBB,
  TitleJunction,
  ButtonRemove,
  FormSection,
  SectionLabel,
  HelpText,
  LocationsContainer,
  LocationPanel,
  PanelHeader,
  ItemCount,
  SearchBox,
  DebouncedInput,
  LocationList,
  TransferButtons,
  TransferButton,
  ButtonCheck,
} from "./expeditionProcessDetail.styled";
import { getDateFormatTimeZone } from "../../../../utils/formats";
import moment from "moment-timezone";
import {
  PROCESS_EXPEDITION_OPEN,
  PROCESS_EXPEDITION_STARTED,
  VARIETIES,
} from "../../../../constants";
import { USER_PERMISSIONS } from "../../../security/permissions/rolesPermission";
import { Can } from "../../../security/permissions/Can";

const ExpeditionProcessDetailView = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    data,
    init,
    onEdit,
    finish,
    onSave,
    exportToExcel,
    onDelete,
    pausedExpedition,
  } = props;

  let sumIn = 0;

  if (data) {
    if (data.expeditionItemsProcess && data.expeditionItemsProcess.length > 0) {
      sumIn = data.expeditionItemsProcess
        .map((bb) => bb.weight)
        .reduce((a, b) => a + b, 0);
      // for (const dataIn of data.inventarys) {
      //   sumIn += dataIn.weight;
      // }
    }
  }

  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.expeditionProcess.title"), path: PATHS.EXPEDITION_LIST },
    { label: t("forms.expeditionDetail.title") },
  ];

  const renderBB = (bbs, isInput = true) => {
    if (bbs && bbs.length > 0) {
      return bbs.map((bb) => {
        return (
          <div className="row mb-1" key={bb.batch}>
            <div className="col-4 col-md-2">{bb.batch}</div>
            <div className="col-4 col-md-2">{`(${bb.numArticle})`}</div>
            <div className="col-4 col-md-2">{`${bb.weight}Kg`}</div>
            <div className="col-6 col-md-3">
              {moment(bb.date).format("DD-MM-yyyy")}
            </div>
            {bb.expeditionCheck && (
              <div className="col-3 col-md-1">
                <ButtonCheck className="disabled">
                  <i className="fa-solid fa-check "></i>
                </ButtonCheck>
              </div>
            )}
            <Can do={USER_PERMISSIONS.VIEW_JUNCTIONS}>
              {(data.status === PROCESS_EXPEDITION_OPEN.code ||
                data.status === PROCESS_EXPEDITION_STARTED.code) && (
                <div className="col-3 col-md-1">
                  <ButtonRemove onClick={() => onDelete(bb.batch)}>
                    <i className="fa-solid fa-trash-can "></i>
                  </ButtonRemove>
                </div>
              )}
            </Can>

            {/* <div className="col-2 text-end">
              {isInput && (
                <ButtonRemove type="button" onClick={() => removeItem(bb)}>
                  <i className="fa-solid fa-trash-can"></i>
                </ButtonRemove>
              )}
            </div> */}
          </div>
        );
      });
    } else {
      return (
        <div className="row">
          <div className="col-12 text-center">{t("forms.inventary.noBb")}</div>
        </div>
      );
    }
  };
  return (
    <>
      {data && (
        <>
          <div className="row justify-content-center">
            <div className="col-6 border p-5">
              <TitleJunction className="col-12 col-md-11 ">
                <div className="d-flex">
                  {`${
                    data?.status === PROCESS_EXPEDITION_OPEN.code
                      ? t("forms.expeditionDetail.processOpen")
                      : t("forms.expeditionDetail.processClosed")
                  } (${getDateFormatTimeZone(data.dateInit, "DD-MM-yyyy")})
                `}
                  {data.status === PROCESS_EXPEDITION_OPEN.code && (
                    <Can do={USER_PERMISSIONS.EDIT_EXPEDITION}> 
                      <div className="d-flex justify-content-end ms-5">
                        <button
                          type="button"
                          className="btn btn-md btn-secondary"
                          onClick={() => onEdit(data)}
                        >
                          {t("forms.expeditionDetail.buttons.editExpedition")}
                        </button>
                      </div>
                    </Can>
                  )}
                </div>
              </TitleJunction>

              <div className="col-12 mt-3">
                <div className="row g-3">
                  <div className="col-12">
                    <div className="mb-2">
                      <strong>{t("forms.expeditionDetail.article")}:</strong>{" "}
                      {data.article}
                    </div>
                    {/* <div className="mb-2">
                      <strong>{t("forms.expeditionDetail.code")}:</strong>{" "}
                      {data.code}
                    </div> */}
                    <div className="mb-2">
                      <strong>{t("forms.expeditionDetail.batchOut")}:</strong>{" "}
                      {data.batchOut}
                    </div>
                    <div className="mb-2">
                      <strong>{t("forms.expeditionDetail.type")}:</strong>{" "}
                      {data.type}
                    </div>
                    {/* </div>
                  <div className="col-12 col-md-6"> */}
                    <div className="mb-2">
                      <strong>{t("forms.expeditionDetail.origen")}:</strong>{" "}
                      {data.origen}
                    </div>
                    <div className="mb-2">
                      <strong>{t("forms.expeditionDetail.propietary")}:</strong>{" "}
                      {data.propietary}
                    </div>
                    <div className="mb-2">
                      <strong>{t("forms.expeditionDetail.priority")}:</strong>{" "}
                      {data.priority}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-6 ">
              <div className="text-end mb-3">
                {data.status === PROCESS_EXPEDITION_OPEN.code && (
                  <Can do={USER_PERMISSIONS.INIT_EXPEDITION}>
                    <button
                      type="button"
                      className="btn btn-md btn-secondary"
                      onClick={() => init()}
                    >
                      {t("forms.expeditionDetail.buttons.initExpedition")}
                    </button>
                  </Can>
                )}
              </div>
              {data.status === PROCESS_EXPEDITION_STARTED.code && (
                <div className="text-end mb-3">
                  <Can do={USER_PERMISSIONS.PAUSED_EXPEDITION}>
                    <button
                      type="button"
                      className="btn btn-md btn-primary me-2"
                      onClick={() => pausedExpedition()}
                    >
                      {t("forms.expeditionDetail.buttons.pausedExpedition")}
                    </button>
                  </Can>
                  <Can do={USER_PERMISSIONS.FINISH_EXPEDITION}>
                    <button
                      type="button"
                      className="btn btn-md btn-secondary"
                      onClick={() => finish()}
                    >
                      {t("forms.expeditionDetail.buttons.finish")}
                    </button>
                  </Can>
                </div>
              )}
              <div className="row">
                <TitleBB className="col-12 d-flex justify-content-between">
                  <div>{t("forms.expeditionDetail.bbIn")}</div>
                  <div>{`Total: ${sumIn} Kg`}</div>
                </TitleBB>
              </div>
              <div className="row">
                <div className="col-12 ">
                  <ContainerBB>
                    {renderBB(data.expeditionItemsProcess)}
                  </ContainerBB>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex col-12 col-md-11 mt-3 mb-3 gap-2">
            {/* {data.status === "OPEN" && (
                <>
                  <button
                    type="button"
                    className="btn btn-mg btn-secondary"
                    onClick={onSave}
                  >
                    {t("forms.inventary.buttons.save")}
                  </button>
                </>
              )} */}

            {/* {data.status === "OPEN" && (
              <>
                
                <button
                  type="button"
                  className="btn btn-md btn-primary"
                  onClick={() => onSave()}
                >
                  {t("forms.expeditionDetail.buttons.addBB")}
                </button>
              </>
            )} */}
          </div>
        </>
      )}
    </>
  );
};

ExpeditionProcessDetailView.propTypes = {
  // handleSubmit: PropTypes.func,
  // initialValues: PropTypes.object,
};

export default ExpeditionProcessDetailView;
